import React, { useContext, useRef } from "react";

import SearchComponent from "./SearchComponent";

import { SearchContext } from "contexts/searchContext";

import useSearchValue from "hooks/useSearchValue";
import useSetSearchValue from "hooks/useSetSearchValue";

const NavBarSearch = () => {
  const { search } = useContext(SearchContext);
  const searchValue = useSearchValue();
  const { clearSearch, setSearchValue } = useSetSearchValue();
  const ref = useRef(null);

  if (!search.enabled) return null;

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      search.onSearch(searchValue);
      ref.current.blur();
    }
  };

  const handleClear = () => {
    clearSearch();
    search.onSearch("");
    ref.current.focus();
  };

  const handleBlur = () => {
    !searchValue.length && search.onSearch(searchValue);
  };

  return (
    <SearchComponent
      placeholder={search.placeholder}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      onClearSearch={handleClear}
      onBlur={handleBlur}
      value={searchValue}
      inputRef={ref}
    />
  );
};

NavBarSearch.propTypes = {};

export default NavBarSearch;
